import { Observable } from 'rxjs';

import { Location } from '../models/location.model';

export abstract class LocationUsecase {
  abstract get locations$(): Observable<Location[]>;
}
